module.exports = __webpack_public_path__ + "media/assets_v3/images/csgo-ranks/4-8d3fdcd70c28e264f6ef2ba986883bc8.png";